<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>Style Dimension Settings</CCardHeader>
      <CCardBody>
        <div class="col-12 float-left">
          <CButton @click="submitWilcom()" color="success">Wilcom</CButton>
          <div style="width:100%;float:left;" v-if="xmlContent">
            <xml-display :data="xmlContent"></xml-display>
          </div>
        </div>
        <div class="col-md-6 float-left" style="float:left;" v-if="styles">
          <label>Select Style</label>
          <v-select :options="styles" v-model="style_selected" @input="getLocations()" label="style_name"></v-select>
        </div>
        <div class="col-md-6 float-left" style="float:left;" v-if="locations">
          <label>Select Location</label>
          <v-select :options="locations" v-model="location" @input="load()" label="location_name"></v-select>
        </div>
        <div style="width:100%;text-align:center;float:left;">
          <div id="wrapper">
            <img v-if="data && data.file" :src="$apiAdress + '/storage/hat_images/' + data.file" style="max-width:100%;max-height:100%;position:absolute;z-index:1;" id="imgWrapper" />
            <div v-else-if="data && !data.file" style="width:100%;float:left;text-align:center;color:#fff;font-weight:900;">
              There is no image loaded for this style and/or this location.
            </div>
            <canvas id="c"></canvas>
            <div v-if="loading" style="position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:21;background:rgba(0,0,0,.3);">
              <small-loader></small-loader>
            </div>
          </div>
        </div>
        <div class="col-12 float-left text-center">
          <CButton @click="save()" size="sm" color="success">Save</CButton>
        </div>
      </CCardBody>
    </CCard>

    <small-notify :toasts="toasts"></small-notify>
  </div>
</template>
<script>
import XmlDisplay from './xml_display'
var methods = {}
const { createCanvas, loadImage } = require('canvas')

methods.submitWilcom = function () {
  axios.post(this.$apiAdress + '/api/submitWilcom?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    this.xmlContent = response.data
  })
}

methods.save = function () {
  this.saveLoading = true
  console.log(this.boxes)
  const postData = {
    style: this.style_selected,
    location: this.location,
    logo_location: this.getLogoArea()
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/saveDesignLocation?token=' + localStorage.getItem('api_token'), postData)
  .then(res => {
    this.toasts.push({ position: 'top-right', autohide: 3000, class: 'success', text: 'Successfully saved.' })
    var that = this
    this.saveLoading = false
    setTimeout(function () {
      that.showToast = false
    }, 3000)
    console.log(res)
  }).catch(e => {
    this.toasts.push({ position: 'top-right', autohide: 3000, class: 'error', text: 'Something went wrong!' })
    var that = this
    this.saveLoading = false
    setTimeout(function () {
      that.showToast = false
    }, 3000)

  })
}

methods.load = function () {
  var that = this
  if (this.style_selected && this.location) {
    this.loading = true
    const postData = {
      style: this.style_selected,
      location: this.location
    }
    console.log(postData)
    axios.post(this.$apiAdress + '/api/getDesignLocation?token=' + localStorage.getItem('api_token'), postData)
    .then(res => {
      console.log(res)
      if (res.data) {
        this.firstClick = null
        this.secondClick = null
        this.data = res.data
        setTimeout(function () {
          that.$emit('img-changed', res)
        }, 1000)
      }
    })
  }
}

methods.getImage = function () {

}

methods.getLogoArea = function () {
  var that = this
  var width = $('#c').width();
  var height = $('#c').height();
  console.log('logo area')
  console.log(width)
  console.log(height)
  // var hRatio = width / that.base_image.width    ;
  // var vRatio = height / that.base_image.height  ;
  // var ratio  = Math.min ( hRatio, vRatio );
  // console.log(ratio)
  var obj = {
    x1: parseFloat(this.boxes[0].x1),
    y1: parseFloat(this.boxes[0].y1),
    x2: parseFloat(this.boxes[0].x2),
    y2: parseFloat(this.boxes[0].y2),
    width: width,
    height: height
  }
  return obj
}

methods.getStyles = function () {
  axios.get(this.$apiAdress + '/api/styles?token=' + localStorage.getItem('api_token'))
  .then(response => {
    this.styles = response.data
  })
}

methods.getLocations = function () {
  this.locations = null
  const postData = {
    style: this.style_selected
  }
  console.log(postData)
  var that = this
  axios.post(this.$apiAdress + '/api/locations/getByStyle?token=' + localStorage.getItem('api_token'), postData)
  .then(response => {
    this.locations = response.data
    if (this.location) {
      var loc = ''
      this.locations.forEach(function (val) {
        if (val.location_name === that.location.location_name) {
          loc = val
        }
      })
      if (loc) {
        this.load()
      } else {
        this.location = null
      }
    }
  })
}

methods.draw = function () {
  this.base_image = new Image();
  this.base_image.src = this.$apiAdress + '/storage/hat_images/S1300-D0H-front.jpg';
  // var otherImage = new Image();
  // otherImage.src = this.$apiAdress + '/storage/svgs/us-open-22.svg'
  var that = this
  var widthRatio = ''
  var heightRatio = ''
  var centerShift_x = ''
  var centerShift_y = ''
  var shiftY2 = ''

}

methods.drawOtherImage = function () {
  console.log('CALLING WILCOM API')
  var theUrl = 'http://ewa.wilcom.com/sandbox/api/info'
  var params = 'appId=16d0b42c&appKey=f807813ef8a886ee328ce924435da1cb'
  var http = new XMLHttpRequest();
    http.open( "POST", theUrl, false ); // false for synchronous request
    // http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    http.send( params );
    console.log(http.responseText);
  // const postData = {
  //   appId: '16d0b42c',
  //   appKey: 'f807813ef8a886ee328ce924435da1cb',
  // }
  // axios.post('http://ewa.wilcom.com/sandbox/api/info', postData).then(response => {
  //   console.log(response)
  // }).catch(e => {
  //   console.log(e)
  // })
  // var otherImage = new Image();
  // otherImage.src = this.$apiAdress + '/storage/svgs/us-open-22.svg'
  // var that = this
  // otherImage.onload = function(){
  //   setTimeout(function (){
  //     // var width2 = widthRatio / 4;
  //     // var height2 = heightRatio / 4;
  //     var width2 = Math.abs(that.secondClick.offsetX - that.firstClick.offsetX)
  //     var height2 = Math.abs(that.firstClick.offsetY - that.secondClick.offsetY)
      
  //     var hRatio2 = width2 / otherImage.width    ;
  //     var vRatio2 = height2 / otherImage.height  ;
  //     var ratio2  = Math.min ( hRatio2, vRatio2 );

  //     var centerShift_x = Math.abs( width2 - otherImage.width*ratio2 ) / 2;
  //     var centerShift_y = Math.abs( height2 - otherImage.height*ratio2 ) / 2;
  //     var heightRatio = Math.abs(otherImage.height*ratio2)
  //     var widthRatio = Math.abs(otherImage.width*ratio2)
  //     var adjustx = parseInt(that.firstClick.offsetX) + ((width2 / 2) - (widthRatio / 2))
  //     var adjusty = parseInt(that.firstClick.offsetY) + ((height2 / 2) - (heightRatio / 2))
  //     that.vueCanvas.drawImage(otherImage, adjustx, adjusty,widthRatio, heightRatio);
  //   }, 1000)
  // }
}

methods.drawIncoming = function () {
  // clear canvas
  // this.vueCanvas.clearRect(0, 0, 200, 200);
  var that = this
  var width = $('#c').width();
  var height = $('#c').height();
  
  this.vueCanvas.beginPath();
  var width2 = parseInt(this.secondClick.offsetX - this.firstClick.offsetX)
  var height2 = parseInt(this.firstClick.offsetY - this.secondClick.offsetY)

  // var offsetX = this.firstClick.offsetX * ratio

  this.vueCanvas.rect(this.firstClick.offsetX, this.secondClick.offsetY, width2, height2);
  this.vueCanvas.stroke();
  this.drawOtherImage()
  console.log(this.vueCanvas) 
}

methods.drawRect = function () {
  // clear canvas
  this.vueCanvas.clearRect(0, 0, 200, 200);
  // console.log(e)
  // draw rect
  this.vueCanvas.beginPath();
  var width = parseFloat(this.secondClick.offsetX - this.firstClick.offsetX)
  var height = parseFloat(this.firstClick.offsetY - this.secondClick.offsetY)


  console.log(width)
  console.log(height)
  this.vueCanvas.rect(this.firstClick.offsetX, this.secondClick.offsetY, width, height);
  this.vueCanvas.stroke();
  console.log(this.vueCanvas) 
}

methods.drawNew = function (res) {
  // this.data = res.data
  var width = $('#c').width();
  var height = $('#c').height();
  console.log(width)
  console.log(height)
  if (res.data.logo_location) {
    var hRatio = width / res.data.logo_location.width    ;
    var vRatio = height / res.data.logo_location.height  ;
    var ratio  = Math.min ( hRatio, vRatio );
    // this.getImage()
    var obj = {
      offsetX: parseFloat(res.data.logo_location.x1 * ratio),
      offsetY: parseFloat(res.data.logo_location.y1 * ratio),
    }
    this.firstClick = obj
    var obj2 = {
      offsetX: parseFloat(res.data.logo_location.x2 * ratio),
      offsetY: parseFloat(res.data.logo_location.y2 * ratio),
    }
    this.secondClick = obj2
    var obj = {

    }
    var that = this
    setTimeout(function () {
      that.drawIncoming()
    }, 500)
  }
}

methods.newCall = function () {
  var lineOffset = 4;
  var anchrSize = 2;
  this.loading = false

  var mousedown = false;
  var clickedArea = {box: -1, pos:'o'};
  var x1 = -1;
  var y1 = -1;
  var x2 = -1;
  var y2 = -1;
  var that = this
  if (this.data.logo_location) {
    that.boxes = [{
      x1: this.data.logo_location.x1,
      y1: this.data.logo_location.y1,
      x2: this.data.logo_location.x2,
      y2: this.data.logo_location.y2,
      color: "DeepSkyBlue",
      lineWidth: 1
    }];
    redraw()
    // newBox(this.data.logo_location.x1,this.data.logo_location.y1,this.data.logo_location.x2,this.data.logo_location.y2)
  } else {
    that.boxes = []
  }
  var tmpBox = null;

  document.getElementById("c").onmousedown = function(e) {
    mousedown = true;
    clickedArea = findCurrentArea(e.offsetX, e.offsetY);
    x1 = e.offsetX;
    y1 = e.offsetY;
    x2 = e.offsetX;
    y2 = e.offsetY;
  };
  document.getElementById("c").onmouseup = function(e) {
    if (clickedArea.box == -1 && tmpBox != null) {
      that.boxes.push(tmpBox);
    } else if (clickedArea.box != -1) {
      var selectedBox = that.boxes[clickedArea.box];
      if (selectedBox.x1 > selectedBox.x2) {
        var previousX1 = selectedBox.x1;
        selectedBox.x1 = selectedBox.x2;
        selectedBox.x2 = previousX1;
      }
      if (selectedBox.y1 > selectedBox.y2) {
        var previousY1 = selectedBox.y1;
        selectedBox.y1 = selectedBox.y2;
        selectedBox.y2 = previousY1;
      }
    }
    clickedArea = {box: -1, pos:'o'};
    tmpBox = null;
    mousedown = false;
    console.log(that.boxes);
  };
  document.getElementById("c").onmouseout = function(e) {
    if (clickedArea.box != -1) {
      var selectedBox = that.boxes[clickedArea.box];
      if (selectedBox.x1 > selectedBox.x2) {
        var previousX1 = selectedBox.x1;
        selectedBox.x1 = selectedBox.x2;
        selectedBox.x2 > previousX1;
      }
      if (selectedBox.y1 > selectedBox.y2) {
        var previousY1 = selectedBox.y1;
        selectedBox.y1 = selectedBox.y2;
        selectedBox.y2 > previousY1;
      }
    }
    mousedown = false;
    clickedArea = {box: -1, pos:'o'};
    tmpBox = null;
  };
  document.getElementById("c").onmousemove = function(e) {
    if (mousedown && clickedArea.box == -1) {
      x2 = e.offsetX;
      y2 = e.offsetY;
      redraw();
    } else if (mousedown && clickedArea.box != -1) {
      x2 = e.offsetX;
      y2 = e.offsetY;
      var xOffset = x2 - x1;
      var yOffset = y2 - y1;
      x1 = x2;
      y1 = y2;

      if (clickedArea.pos == 'i'  ||
          clickedArea.pos == 'tl' ||
          clickedArea.pos == 'l'  ||
          clickedArea.pos == 'bl') {
        that.boxes[clickedArea.box].x1 += xOffset;
      }
      if (clickedArea.pos == 'i'  ||
          clickedArea.pos == 'tl' ||
          clickedArea.pos == 't'  ||
          clickedArea.pos == 'tr') {
        that.boxes[clickedArea.box].y1 += yOffset;
      }
      if (clickedArea.pos == 'i'  ||
          clickedArea.pos == 'tr' ||
          clickedArea.pos == 'r'  ||
          clickedArea.pos == 'br') {
        that.boxes[clickedArea.box].x2 += xOffset;
      }
      if (clickedArea.pos == 'i'  ||
          clickedArea.pos == 'bl' ||
          clickedArea.pos == 'b'  ||
          clickedArea.pos == 'br') {
        that.boxes[clickedArea.box].y2 += yOffset;
      }
      redraw();
    }
  }

  function redraw() {
    // canvas.width = canvas.width;
    var context = document.getElementById("c").getContext('2d');
    context.clearRect(0, 0, 800, 600);
    context.beginPath();
    for (var i = 0; i < that.boxes.length; i++) {
      drawBoxOn(that.boxes[i], context);
    }
    if (clickedArea.box == -1) {
      tmpBox = newBox(x1, y1, x2, y2);
      if (tmpBox != null) {
        drawBoxOn(tmpBox, context);
      }
    }
  }

  function findCurrentArea(x, y) {
    for (var i = 0; i < that.boxes.length; i++) {
      var box = that.boxes[i];
      var xCenter = box.x1 + (box.x2 - box.x1) / 2;
      var yCenter = box.y1 + (box.y2 - box.y1) / 2;
      if (box.x1 - lineOffset <  x && x < box.x1 + lineOffset) {
        if (box.y1 - lineOffset <  y && y < box.y1 + lineOffset) {
          return {box: i, pos:'tl'};
        } else if (box.y2 - lineOffset <  y && y < box.y2 + lineOffset) {
          return {box: i, pos:'bl'};
        } else if (yCenter - lineOffset <  y && y < yCenter + lineOffset) {
          return {box: i, pos:'l'};
        }
      } else if (box.x2 - lineOffset < x && x < box.x2 + lineOffset) {
        if (box.y1 - lineOffset <  y && y < box.y1 + lineOffset) {
          return {box: i, pos:'tr'};
        } else if (box.y2 - lineOffset <  y && y < box.y2 + lineOffset) {
          return {box: i, pos:'br'};
        } else if (yCenter - lineOffset <  y && y < yCenter + lineOffset) {
          return {box: i, pos:'r'};
        }
      } else if (xCenter - lineOffset <  x && x < xCenter + lineOffset) {
        if (box.y1 - lineOffset <  y && y < box.y1 + lineOffset) {
          return {box: i, pos:'t'};
        } else if (box.y2 - lineOffset <  y && y < box.y2 + lineOffset) {
          return {box: i, pos:'b'};
        } else if (box.y1 - lineOffset <  y && y < box.y2 + lineOffset) {
          return {box: i, pos:'i'};
        }
      } else if (box.x1 - lineOffset <  x && x < box.x2 + lineOffset) {
        if (box.y1 - lineOffset <  y && y < box.y2 + lineOffset) {
          return {box: i, pos:'i'};
        }
      }
    }
    return {box: -1, pos:'o'};
  }

  function newBox(x1, y1, x2, y2) {
    console.log('new box')
    console.log(x1)
    console.log(x2)
    console.log(y1)
    console.log(y2)
    var boxX1 = x1 < x2 ? x1 : x2;
    var boxY1 = y1 < y2 ? y1 : y2;
    var boxX2 = x1 > x2 ? x1 : x2;
    var boxY2 = y1 > y2 ? y1 : y2;
    if (boxX2 - boxX1 > lineOffset * 2 && boxY2 - boxY1 > lineOffset * 2) {
      return {x1: boxX1,
              y1: boxY1,
              x2: boxX2,
              y2: boxY2,
              lineWidth: 1,
              color: 'DeepSkyBlue'};
    } else {
      return null;
    }
  }

  function drawBoxOn(box, context) {
    var xCenter = box.x1 + (box.x2 - box.x1) / 2;
    var yCenter = box.y1 + (box.y2 - box.y1) / 2;

    context.strokeStyle = box.color;
    context.fillStyle = box.color;

    context.rect(box.x1, box.y1, (box.x2 - box.x1), (box.y2 - box.y1));
    context.lineWidth = box.lineWidth;
    context.stroke();

    context.fillRect(box.x1 - anchrSize, box.y1 - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(box.x1 - anchrSize, yCenter - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(box.x1 - anchrSize, box.y2 - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(xCenter - anchrSize, box.y1 - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(xCenter - anchrSize, yCenter - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(xCenter - anchrSize, box.y2 - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(box.x2 - anchrSize, box.y1 - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(box.x2 - anchrSize, yCenter - anchrSize, 2 * anchrSize, 2 * anchrSize);
    context.fillRect(box.x2 - anchrSize, box.y2 - anchrSize, 2 * anchrSize, 2 * anchrSize);
  }
}

export default {
    // ===Component name
    name: "Designer",
    // ===Props passed to component
    props: [],
    // ===Components used by this component
    components: {
      XmlDisplay
    },
    // ====component Data properties
    data(){
        return{
          vueCanvas: null,
          data: null,
          base_image: null,
          toastStyle: '',
          toasts: [],
          width: '500',
          height: '500',
          firstClick: null,
          secondClick: null,
          showToast: false,
          rectWidth: 100,
          styles: null,
          locations: null,
          style_selected: null,
          location: null,
          boxes: null,
          loading: false,
          xmlContent: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      // var c = document.getElementById("c");
      // var ctx = c.getContext("2d");    
      // this.vueCanvas = ctx;
      // this.draw()

      this.getStyles()
      // this.getLocations()
      console.log(this.order)
      var that = this
      this.$on('img-changed', function (res) {
        console.log('img changed')
        console.log(res)
        setTimeout(function () {
          that.newCall()
        }, 500)
        that.element = document.getElementById('c');
        console.log(that.element)
        var id = 'test'
        var width = $('#imgWrapper').width()
        var height = $('#imgWrapper').height()
        $(that.element)
           // .attr('id', id)
           .text('unsupported browser')
           .attr('width', width)       // for pixels
           .attr('height', height)
           .width(width)               // for CSS scaling
           .height(height);
           // .appendTo('#c');

        // $(that.element).on('mousedown', function (e) {
        //   console.log('MOUSE DOWN')
        //   console.log(e)
        //   if (that.firstClick && that.secondClick) {
        //     var width = parseFloat(that.secondClick.offsetX - that.firstClick.offsetX) + 10
        //     var height = parseFloat(that.secondClick.offsetY - that.firstClick.offsetY) + 10
        //     console.log(width)
        //     console.log(height)
        //     that.vueCanvas.clearRect(that.firstClick.offsetX - 4, that.firstClick.offsetY - 4,width,height);
        //   }
        //   that.firstClick = e
        // })

        // $(that.element).on('mouseup', function (e) {
        //   console.log('MOUSE UP')
        //   console.log(e)
        //   that.secondClick = e
        //   that.drawRect()
        // })

        $(that.element).on('click', function (e) {
          // console.log(e)
          // // that.drawRect(e)
          // if (that.firstClick && that.secondClick) {
          //   // that.vueCanvas.clearRect(0, 0, WIDTH, HEIGHT);
          //   var width = parseInt(that.secondClick.offsetX - that.firstClick.offsetX)
          //   var height = parseInt(that.firstClick.offsetY - that.secondClick.offsetY)
          //   console.log(width)
          //   console.log(height)
          //   that.vueCanvas.clearRect(that.firstClick.offsetX, that.secondClick.offsetY, width, height);
          //   that.firstClick = null
          //   that.secondClick = null
          //   that.draw()
          // } else if (!that.firstClick) {
          //   that.firstClick = e
          // } else if (that.firstClick) {
          //   that.secondClick = e
          //   that.drawRect()
          // }
        })

        that.vueCanvas = that.element.getContext("2d");

        console.log(that.vueCanvas)

        // that.vueCanvas.onclick = function (e) {
        //   console.log(e)
        //     if (element !== null) {
        //         element = null;
        //         canvas.style.cursor = "default";
        //         console.log("finsihed.");
        //     } else {
        //         console.log("begun.");
        //         mouse.startX = mouse.x;
        //         mouse.startY = mouse.y;
        //         element = document.createElement('div');
        //         element.className = 'rectangle'
        //         element.style.left = mouse.x + 'px';
        //         element.style.top = mouse.y + 'px';
        //         canvas.appendChild(element)
        //         canvas.style.cursor = "crosshair";
        //     }
        // }
        // var that = this
        setTimeout(function () {
          // that.draw()
          that.drawNew(res)
        }, 1000)
      })
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  #wrapper {
    display:inline-block;
    width:400px; 
    height:400px;
    margin: 0 auto; 
    background: black; 
    position:relative; 
    border:3px solid grey; 
    margin-top:15px;

    #imgWrapper {
      position: absolute !important;
      z-index:1;
    }

    #c {
      position: relative !important;
      z-index: 20;
      height:100%;
      width:100%;
    }
  }
</style>
